export const config = {
  environment: import.meta.env.MODE || 'development',
  api: {
    baseUrl:
      import.meta.env.VITE_API_BASE_URL ||
      (import.meta.env.MODE === 'development' ? 'http://localhost:3001' : 'https://api.swag.live'),
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '10000', 10),
  },
  assets: {
    iconBaseUrl: import.meta.env.VITE_ICON_BASE_URL || 'https://public-ws.swag.live/notifications/shop-ad/',
  },
  debug: {
    enableLogging: import.meta.env.MODE !== 'production',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  },
};

// 調試輔助函數
export const shouldLog = (level: 'debug' | 'info' | 'warn' | 'error' = 'info'): boolean => {
  if (!config.debug.enableLogging) return false;

  const levels = ['debug', 'info', 'warn', 'error'];
  const currentLevelIndex = levels.indexOf(config.debug.logLevel);
  const requestedLevelIndex = levels.indexOf(level);

  return requestedLevelIndex >= currentLevelIndex;
};
